import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ErrorViewProps {
  message?: string;
}

const ErrorView: React.FC<ErrorViewProps> = ({ message }) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen page-bg flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-dashboard border border-slate-200 overflow-hidden">

        {/* Red top bar */}
        <div className="h-1.5 bg-gradient-to-r from-red-400 to-red-600" />

        <div className="p-8 space-y-6">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="w-20 h-20 rounded-full bg-red-50 border border-red-100 flex items-center justify-center">
              <AlertCircle className="h-10 w-10 text-red-500" />
            </div>
          </div>

          {/* Text */}
          <div className="text-center space-y-2">
            <h2 className="font-display text-2xl font-semibold tracking-tight text-slate-900">{t('error.title')}</h2>
            <p className="text-slate-500 leading-relaxed">
              {message ?? t('error.defaultMessage')}
            </p>
          </div>

          {/* Actions */}
          <div className="space-y-3 pt-2">
            <button
              onClick={() => window.location.reload()}
              className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl border border-slate-200 bg-white text-slate-700 font-medium hover:bg-slate-50 transition-colors"
            >
              <RefreshCw className="h-4 w-4" />
              {t('error.retry')}
            </button>

          </div>

          <p className="text-center text-xs text-slate-500">
            {t('error.expiredLink')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorView;
